import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../components/form";
import { InputConnectedProps } from "../../components/input.type";
import { CheckboxInput } from "./checkbox-input";

export function CheckboxInputConnected({
  id,
  name,
  label,
  className,
  description,
  required,
  disabled,
  onChange,
}: InputConnectedProps & { onChange?: (checked: boolean) => void }) {
  const form = useFormContext();

  if (!form) {
    throw new Error("CheckboxConnected must be used within a Form component");
  }

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={className}>
          <div className="flex items-center gap-2">
            <FormControl>
              <CheckboxInput
                id={id}
                key={`${name} ${field.value}`}
                disabled={disabled}
                checked={field.value}
                onCheckedChange={(checked) => {
                  field?.onChange(checked);
                  if (onChange && typeof checked === "boolean") {
                    onChange(checked);
                  }
                }}
                {...field}
              />
            </FormControl>
            {label && <FormLabel required={required}>{label}</FormLabel>}
          </div>
          {fieldState?.error ? (
            <FormMessage />
          ) : (
            description && <FormDescription>{description}</FormDescription>
          )}
        </FormItem>
      )}
    />
  );
}
